import React, { useRef } from 'react'
import { App_url } from '../utils/constants/static'
import gsap from 'gsap';

const Footer = () => {
    const firstRef = useRef<HTMLAnchorElement | null>(null);
    const secondRef = useRef<HTMLAnchorElement | null>(null);
    const topRef = useRef<HTMLAnchorElement | null>(null);

    const handleMouseEnter = (el: HTMLAnchorElement | null) => {
        if (!el) return;
        const [main, copy] = el.querySelectorAll(".text-layer");
        if (!main || !copy) return;

        const mainChars = main.querySelectorAll("span");
        const copyChars = copy.querySelectorAll("span");

        gsap.to(mainChars, {
            y: -20,
            opacity: 0.6,
            ease: "power2.out",
            stagger: 0.03,
            duration: 0.4,
        });

        gsap.fromTo(
            copyChars,
            { y: 20, opacity: 0 },
            {
                y: 0,
                opacity: 1,
                ease: "power3.out",
                stagger: 0.03,
                duration: 0.6,
            }
        );
    }

    const handleMouseLeave = (el: HTMLAnchorElement | null) => {
        if (!el) return;
        const [main, copy] = el.querySelectorAll(".text-layer");
        if (!main || !copy) return;

        const mainChars = main.querySelectorAll("span");
        const copyChars = copy.querySelectorAll("span");

        gsap.to(copyChars, {
            y: 20,
            opacity: 0,
            ease: "power2.in",
            stagger: {
                each: 0.03,
                from: "end"
            },
            duration: 0.4,
        });

        gsap.fromTo(
            mainChars,
            { y: -20, opacity: 0 },
            {
                y: 0,
                opacity: 1,
                ease: "power2.out",
                stagger: {
                    each: 0.03,
                    from: "end"
                },
                duration: 0.6,
            }
        );
    };

    const firstText = "NING HUNG"
    return (
        <div className='bg-black relative w-full flex-shrink-0 bg-cover bg-center'>
            <div className='w-full px-[3rem] pb-[2rem] flex justify-between'>
                <div className='flex flex-col gap-[1rem] text-[12px] z-4'>
                    <div className='flex gap-[12px]'>
                        <p className='uppercase'>Develop</p>
                        <p>|</p>
                        <a
                            ref={firstRef}
                            href='https://ning-h.com/'
                            target='_blank'
                            rel='noreferrer'
                            className='pointer-events-auto cursor-pointer overflow-hidden mt-[5px]'
                            onMouseEnter={() => handleMouseEnter(firstRef.current)}
                            onMouseLeave={() => handleMouseLeave(firstRef.current)}
                        >
                            <div className='flex flex-row relative overflow-hidden leading-none'>
                                <div className='text-layer relative flex z-10'>
                                    {firstText.split('').map((char, i) => (
                                        <span className='inline-block'>
                                            {char}
                                        </span>
                                    ))}
                                </div>
                                <div className='text-layer absolute top-0 left-0 flex'>
                                    {firstText.split('').map((char, i) => (
                                        <span className='inline-block' >
                                            {char}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className='flex gap-[12px]'>
                        <p className='uppercase'>Design</p>
                        <p>|</p>
                        <a
                            ref={secondRef}
                            href='https://www.instagram.com/una.uei/'
                            target='_blank'
                            rel='noreferrer'
                            className='pointer-events-auto cursor-pointer overflow-hidden mt-[5px]'
                            onMouseEnter={() => handleMouseEnter(secondRef.current)}
                            onMouseLeave={() => handleMouseLeave(secondRef.current)}
                        >
                            <div className='flex flex-row relative overflow-hidden leading-none'>
                                <div className='text-layer relative flex z-10'>
                                    {"UN@DSGN".split('').map((char, i) => (
                                        <span className=' inline-block'>
                                            {char}
                                        </span>
                                    ))}
                                </div>
                                <div className='text-layer absolute top-0 left-0 flex'>
                                    {"UN@DSGN".split('').map((char, i) => (
                                        <span className=' inline-block' >
                                            {char}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
                <a
                    ref={topRef}
                    href='#'
                    target='_blank'
                    rel='noreferrer'
                    className='cursor-pointer'
                    onMouseEnter={() => handleMouseEnter(topRef.current)}
                    onMouseLeave={() => handleMouseLeave(topRef.current)}
                >
                    <div className='flex flex-row relative overflow-hidden'>
                        <div className='text-layer relative flex z-10'>
                            {"BACK TO TOP".split('').map((char, i) => (
                                <span className='inline-block'>
                                    {char}
                                </span>
                            ))}
                        </div>
                        <div className='text-layer absolute top-0 left-0 flex'>
                            {"BACK TO TOP".split('').map((char, i) => (
                                <span className='inline-block' >
                                    {char}
                                </span>
                            ))}
                        </div>
                    </div>
                </a>
            </div>
            <div className='h-[24vh] overflow-clip'>
                <img
                    src={`${App_url.image.footer_logo}`}
                    alt='footer logo'
                // className='w-full h-full object-fill'
                />
            </div>

        </div>
    )
}

export default Footer
